import React, { useEffect, useState } from "react";
import {
  getApprovalLevels,
  getApprovalTypes,
  getBooleanOperations,
    getResourceDetails,
  getRoleDetails,
  insertApprovalMatrix
} from "../Api/ApprovalMatrixApi";
import { toast } from "react-toastify";
import { useAuth } from "../Context/AuthContext";
import "../Styling/ApprovalMatrixConfig.css";


const ApprovalMatrixConfig = () => {
  const { user } = useAuth();

  const [headerDesc, setHeaderDesc] = useState("");

  const [levels, setLevels] = useState([]);
  const [types, setTypes] = useState([]);
  const [booleans, setBooleans] = useState([]);

const [items, setItems] = useState([
  {
    levelGuid: "",
    typeGuid: "",
    booleanGuid: "",
    typeValueGuid: "",
    typeValues: [],
  },
]);

  useEffect(() => {
    fetchDropdowns();
  }, []);

  const fetchDropdowns = async () => {
    try {
      const [lvl, typ, bool] = await Promise.all([
        getApprovalLevels(),
        getApprovalTypes(),
        getBooleanOperations(),
      ]);

      setLevels(lvl);
      setTypes(typ);
      setBooleans(bool);
    } catch (err) {
      console.error(err);
    }
  };
const handleTypeChange = async (index, typeGuid) => {
  const updated = [...items];

  updated[index].typeGuid = typeGuid;
  updated[index].typeValueGuid = "";
  updated[index].typeValues = [];

  try {
    const selectedType = types.find(
      (t) => t.ApprovalTypeMasterGUID === typeGuid
    );

    if (!selectedType) return;

    let data = [];

    if (selectedType.TypeMasterTable === "Resource_master") {
      data = await getResourceDetails(user?.organisationId);
    } else if (selectedType.TypeMasterTable === "role_master") {
      data = await getRoleDetails(user?.organisationId);
    }

    updated[index].typeValues = data;
    setItems(updated);
  } catch (err) {
    console.error(err);
  }
};
  const handleChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

 const addItem = () => {
  setItems([
    ...items,
    {
      levelGuid: "",
      typeGuid: "",
      booleanGuid: "",
      typeValueGuid: "",
      typeValues: [],
    },
  ]);
};

  const removeItem = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
  };

  const handleSubmit = async() => {
   const payload = {
  HeaderDescription: headerDesc,
  organisationId: user?.organisationId,
  userId: user?.userId,
  Items: items.map((item) => ({
    ApprovalLevelGuid: item.levelGuid,
    ApprovalTypeGuid: item.typeGuid,
    TypeValueGuid: item.typeValueGuid, // 🔥 NEW
    BooleanGuid: item.booleanGuid,
  })),
  
};
try{
    const res = await insertApprovalMatrix(payload);
    toast.success("Approval Matrix saved successfully!");

}
catch(err){
    console.error(err);
    toast.error("Failed to save Approval Matrix");
}
  };

  return (
    <div className="approvalMatrix-container">
      <h2 className="approvalMatrix-title">Approval Matrix Config</h2>

      {/* HEADER SECTION */}
      <div className="approvalMatrix-card">
        <h3>Approval Matrix Header</h3>
        <input
          type="text"
          placeholder="Enter Header Description"
          value={headerDesc}
          onChange={(e) => setHeaderDesc(e.target.value)}
          className="approvalMatrix-input"
        />
      </div>

      {/* ITEMS SECTION */}
      <div className="approvalMatrix-card">
        <h3>Approval Matrix Items</h3>

        {items.map((item, index) => (
          <div key={index} className="approvalMatrix-row">

            {/* Approval Level */}
            <select
              value={item.levelGuid}
              onChange={(e) =>
                handleChange(index, "levelGuid", e.target.value)
              }
            >
              <option value="">Select Level</option>
              {levels.map((lvl) => (
                <option
                  key={lvl.ApprovalLevelMasterGUID}
                  value={lvl.ApprovalLevelMasterGUID}
                >
                  {lvl.ApprovalLevelCode} - {lvl.ApprovalLevelDesc}
                </option>
              ))}
            </select>

            {/* Approval Type */}
           {/* Approval Type */}
<select
  value={item.typeGuid}
  onChange={(e) => handleTypeChange(index, e.target.value)}
>
  <option value="">Select Type</option>
  {types.map((t) => (
    <option
      key={t.ApprovalTypeMasterGUID}
      value={t.ApprovalTypeMasterGUID}
    >
      {t.ApprovalTypeDesc}
    </option>
  ))}
</select>

{/* Type Value (NEW 🔥) */}
<select
  value={item.typeValueGuid}
  onChange={(e) =>
    handleChange(index, "typeValueGuid", e.target.value)
  }
>
  <option value="">Select Value</option>
  {item.typeValues?.map((val) => (
    <option key={val.GUID} value={val.GUID}>
      {val.Name}
    </option>
  ))}
</select>

            {/* Boolean */}
            <select
              value={item.booleanGuid}
              onChange={(e) =>
                handleChange(index, "booleanGuid", e.target.value)
              }
            >
              <option value="">Select Condition</option>
              {booleans.map((b) => (
                <option
                  key={b.BooleanOperationMasterGUID}
                  value={b.BooleanOperationMasterGUID}
                >
                  {b.BooleanOperationSymbol}
                </option>
              ))}
            </select>

            <button
              className="approvalMatrix-remove"
              onClick={() => removeItem(index)}
            >
              Remove
            </button>
          </div>
        ))}

        <button className="approvalMatrix-add" onClick={addItem}>
          + Add Item
        </button>
      </div>

      <button className="approvalMatrix-submit" onClick={handleSubmit}>
        Save Matrix
      </button>
    </div>
  );
};

export default ApprovalMatrixConfig;